import { Component, OnInit } from '@angular/core';
import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface,
} from "ngx-swiper-wrapper";
@Component({
  selector: 'app-player-ticket',
  templateUrl: './player-ticket.component.html',
  styleUrls: ['./player-ticket.component.scss']
})
export class PlayerTicketComponent implements OnInit {
  public Top_config: SwiperConfigInterface = {
    direction: "horizontal",
    grabCursor: true,
    centeredSlides: true,
    effect: "slide",
    // coverflowEffect: {
    //   rotate: 0,
    //   stretch: 0,
    //   depth: 100,
    //   modifier: 3,
    //   slideShadows: true,
    // },
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false
    // },
    loop: true,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    // navigation: false,
    navigation: {
      nextEl: ".contestnext",
      prevEl: ".contestprev",
    },
    breakpoints: {
      // 320: {
      //   slidesPerView: 1,
      //   spaceBetween: 0,
      //   centeredSlides: false,
      // },
      // 480: {
      //   slidesPerView: 1,
      //   spaceBetween: 0,
      //   centeredSlides: false,
      // },
      // 767: {
      //   slidesPerView: 1,
      //   spaceBetween: 0,
      //   centeredSlides: false,
      // },
      // 768: {
      //   slidesPerView: 1,
      //   spaceBetween: 0,
      //   centeredSlides: false,
      // },
      // 850: {
      //   slidesPerView: 1,
      //   spaceBetween: 0,
      //   centeredSlides: false,
      // },
      // 851: {
      //   slidesPerView: 2,
      //   spaceBetween: 0,
      //   centeredSlides: false,
      // },
      // 992: {
      //   slidesPerView: 2,
      //   spaceBetween: 0,
      //   centeredSlides: false,
      // },
      // 1199: {
      //   slidesPerView: 2,
      //   spaceBetween: 0,
      //   centeredSlides: false,
      // },
      // 1200: {
      //   slidesPerView: 3,
      //   spaceBetween: 0,
        
      // },
    },
  };
  constructor() { }

  ngOnInit(): void {
  }

}
